/** Иконка «Флоу» для карточек-источников: S-связь между двумя портами узлов.
 *  Выбор владельца 05.09.2026 из серии вариантов: сильный изгиб, кольца r 2.2,
 *  линия и кольца одной толщины 1.1, currentColor. Та же иконка в админке
 *  (редактор карточки «Популярных», режим «Флоу»). */
export function FlowLinkIcon({ size = 18, className }: { size?: number; className?: string }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={1.1}
			strokeLinecap="round"
			className={className}
			aria-hidden="true"
		>
			<path d="M7.7 18.5 C 16.5 18.5, 7.5 5.5, 16.3 5.5" />
			<circle cx="5.5" cy="18.5" r="2.2" />
			<circle cx="18.5" cy="5.5" r="2.2" />
		</svg>
	)
}

export default FlowLinkIcon
